// extracted by mini-css-extract-plugin
module.exports = {"poster":"hero-poster-server_poster__uCQfz"};